import { Locale } from "../Locale.js";
import { getPathInLocale } from "./getPathInLocale.js";

export function getAboutPath(locale: Locale): string {
	return getPathInLocale(locale, {
		[Locale.cs]: "/#o-prenosnem-ohnisti",
	});
}
